import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    marginBottom: '0px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px'
  },

  title: {
    marginBottom: '5px',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  root: {
    margin: '1rem',

    '& span': {
      fontSize: theme.size.sm
    }
  },

  button: {
    borderRadius: '8px',
    width: '100%',
    fontSize: theme.size.base
  }
}))

export default useStyles
